// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c8207-pageHead{display:flex;align-items:center;margin-bottom:32px}.bc415-titleContainer{flex:1}", "",{"version":3,"sources":["webpack://./app/components/PageHead/style.scss"],"names":[],"mappings":"AAAA,gBACE,YAAA,CACA,kBAAA,CACA,kBAAA,CAGF,sBACE,MAAA","sourcesContent":[".pageHead {\n  display: flex;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.titleContainer {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHead": "c8207-pageHead",
	"titleContainer": "bc415-titleContainer"
};
export default ___CSS_LOADER_EXPORT___;
